export const iconFontAwesomeUsersPeopleUsersRectangle = (
	<i className="fa-solid fa-users-rectangle"></i>
);
